export const QUERY_KEYS = {
  GET_GENERAL_PREFERENCE_V2: "GET_GENERAL_PREFERENCE_V2",
};
